import styled from "styled-components";

export const PriceInfoContainer = styled.div`
  display: block; 
  margin-left: auto;
  width: fit-content;
  text-align: right;
  position: relative;
`

export const PriceInfoButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  color: #1b5f4c;
  text-decoration: none;
  cursor: pointer;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: 'aktiv-grotesk', sans-serif;
    
  svg {
    margin-right: 4px;
    width: 13px;
    height: 13px;
  }
`;

export const InfoBubble = styled.div`
  position: absolute;
  background: #fff;
  filter: drop-shadow(0 0 3px #a3a3a3);
  text-align: center;
  width: 250px;
  border-radius: 4px;
  right: 0;
  bottom: 40px;
  z-index: 1;
  padding: 12px 20px;
  position: absolute;

  @media (min-width: 1200px) {
    right: -50px;
  }

  &:after {
    content: "";
    position: absolute;
    display: block;
    width: 0;
    z-index: 1;
    border-style: solid;
    border-color: #ffffff transparent;
    border-width: 10px 10px 0;
    bottom: -10px;
    left: 80%;
    margin-left: -10px;
    
    @media (min-width: 1200px) {
      left: 85%;
    }
    
    @media (min-width: 1200px) {
      left: 50%;
    }
  }
`

export const InfoBubbleText = styled.p`
  color: #666;
  font-family: 'aktiv-grotesk', sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: unset;
  margin-top: 0;
`;
